var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-badge',{class:("border-color-" + (_vm.config.textColor)),attrs:{"color":"black","outline":"","align":_vm.align}},[_vm._v(" "+_vm._s(_vm.config.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }